export const environment = {
	production: true,
	apiUrl: 'https://api-distributor.bertazzoni.com/api-bertazzoni/',
	apiImages: 'https://api-distributor.bertazzoni.com/api-bertazzoni/images/',
	lang: 'us',
	mailFrom: 'customer@bertazzoni.com',
	logHttp: false,

	buildNumber: '1',
	sentryDsn: 'https://f5971da8ffd099b0623ff2e5e1b8947e@o4507090121916416.ingest.de.sentry.io/4508375722426448',
	nomeProgettoSentry: 'bertazzoni-portale-clienti-fe',

	// Lista di ID linea estetica neutral
	idNeutral: [
		'MC_P-Cod.Serie1|+1108',
		'MC_P-Cod.Serie1|+1608',
		'MC_P-Cod.Serie1|+8111',
		'MC_P-Cod.Serie1|+2603',
		'MC_P-Cod.Serie1|+4612',
		'MC_P-Cod.Serie1|+8111',
	],
	idHeritage: [
		'MC_P-Cod.Serie1|+0603',
		'MC_P-Cod.Serie1|+1102',
		'MC_P-Cod.Serie1|+1602',
		'MC_P-Cod.Serie1|+2601',
		'MC_P-Cod.Serie1|+4602',
		'MC_P-Cod.Serie1|+8102',
	],

	// Lista di linee estetiche rappresentanti 1-PROFESSIONAL 2-MASTER 3-HERITAGE 4-AMERICANA 5-FUTURA 6-PRIMA 7-STILE
	ordineSerie: [
		{
			nome: 'MC_P-Cod.Serie1|+0609;MC_P-Cod.Serie1|+1099;MC_P-Cod.Serie1|+1599;MC_P-Cod.Serie1|+2599;MC_P-Cod.Serie1|+4599;MC_P-Cod.Serie1|+8099',
			ordine: 1,
		},
		{
			nome: 'MC_P-Cod.Serie1|+0604;MC_P-Cod.Serie1|+1101;MC_P-Cod.Serie1|+1601;MC_P-Cod.Serie1|+2600;MC_P-Cod.Serie1|+4601;MC_P-Cod.Serie1|+8101',
			ordine: 2,
		},
		{
			nome: 'MC_P-Cod.Serie1|+0603;MC_P-Cod.Serie1|+1102;MC_P-Cod.Serie1|+1602;MC_P-Cod.Serie1|+2601;MC_P-Cod.Serie1|+4602;MC_P-Cod.Serie1|+8102',
			ordine: 3,
		},

		{ nome: 'MC_P-Cod.Serie1|+0599;MC_P-Cod.Serie1|+4604;MC_P-Cod.Serie1|+8104;', ordine: 4 },
		{ nome: 'MC_P-Cod.Serie1|+0602;MC_P-Cod.Serie1|+1104;MC_P-Cod.Serie1|+1604;MC_P-Cod.Serie1|+4605;MC_P-Cod.Serie1|+8105;', ordine: 5 },
		{ nome: 'MC_P-Cod.Serie1|+0608;MC_P-Cod.Serie1|+4606;MC_P-Cod.Serie1|+8106;', ordine: 6 },
		{ nome: 'MC_P-Cod.Serie1|+0610;MC_P-Cod.Serie1|+4608;MC_P-Cod.Serie1|+8108;', ordine: 7 },
	],

	// Associazione categoria - linea estetica
	serieCategoria: [
		// 1-PROFESSIONAL
		[
			{ categoria: 'MC_P-CodLineaProdotto|05', serie: 'MC_P-Cod.Serie1|+0609' },
			{ categoria: 'MC_P-CodLineaProdotto|10', serie: 'MC_P-Cod.Serie1|+1099' },
			{ categoria: 'MC_P-CodLineaProdotto|15', serie: 'MC_P-Cod.Serie1|+1599' },
			{ categoria: 'MC_P-CodLineaProdotto|25', serie: 'MC_P-Cod.Serie1|+2599' },
			{ categoria: 'MC_P-CodLineaProdotto|45', serie: 'MC_P-Cod.Serie1|+4599' },
			{ categoria: 'MC_P-CodLineaProdotto|80', serie: 'MC_P-Cod.Serie1|+8099' },
		],
		// 2-MASTER
		[
			{ categoria: 'MC_P-CodLineaProdotto|05', serie: 'MC_P-Cod.Serie1|+0604' },
			{ categoria: 'MC_P-CodLineaProdotto|10', serie: 'MC_P-Cod.Serie1|+1101' },
			{ categoria: 'MC_P-CodLineaProdotto|15', serie: 'MC_P-Cod.Serie1|+1601' },
			{ categoria: 'MC_P-CodLineaProdotto|25', serie: 'MC_P-Cod.Serie1|+2600' },
			{ categoria: 'MC_P-CodLineaProdotto|45', serie: 'MC_P-Cod.Serie1|+4601' },
			{ categoria: 'MC_P-CodLineaProdotto|80', serie: 'MC_P-Cod.Serie1|+8101' },
		],
		// 3-HERITAGE
		[
			{ categoria: 'MC_P-CodLineaProdotto|05', serie: 'MC_P-Cod.Serie1|+0603' },
			{ categoria: 'MC_P-CodLineaProdotto|10', serie: 'MC_P-Cod.Serie1|+1102' },
			{ categoria: 'MC_P-CodLineaProdotto|15', serie: 'MC_P-Cod.Serie1|+1602' },
			{ categoria: 'MC_P-CodLineaProdotto|25', serie: 'MC_P-Cod.Serie1|+2601' },
			{ categoria: 'MC_P-CodLineaProdotto|45', serie: 'MC_P-Cod.Serie1|+4602' },
			{ categoria: 'MC_P-CodLineaProdotto|80', serie: 'MC_P-Cod.Serie1|+8102' },
		],
		// 4-AMERICANA
		[
			{ categoria: 'MC_P-CodLineaProdotto|05', serie: 'MC_P-Cod.Serie1|+0599' },
			{ categoria: 'MC_P-CodLineaProdotto|45', serie: 'MC_P-Cod.Serie1|+4604' },
			{ categoria: 'MC_P-CodLineaProdotto|80', serie: 'MC_P-Cod.Serie1|+8104' },
		],
		// 5-FUTURA
		[
			{ categoria: 'MC_P-CodLineaProdotto|05', serie: 'MC_P-Cod.Serie1|+0602' },
			{ categoria: 'MC_P-CodLineaProdotto|10', serie: 'MC_P-Cod.Serie1|+1104' },
			{ categoria: 'MC_P-CodLineaProdotto|15', serie: 'MC_P-Cod.Serie1|+1604' },
			{ categoria: 'MC_P-CodLineaProdotto|45', serie: 'MC_P-Cod.Serie1|+4605' },
			{ categoria: 'MC_P-CodLineaProdotto|80', serie: 'MC_P-Cod.Serie1|+8105' },
		],
		// 6-PRIMA
		[
			{ categoria: 'MC_P-CodLineaProdotto|05', serie: 'MC_P-Cod.Serie1|+0608' },
			{ categoria: 'MC_P-CodLineaProdotto|45', serie: 'MC_P-Cod.Serie1|+4606' },
			{ categoria: 'MC_P-CodLineaProdotto|80', serie: 'MC_P-Cod.Serie1|+8106' },
		],
		// 7-STILE
		[
			{ categoria: 'MC_P-CodLineaProdotto|05', serie: 'MC_P-Cod.Serie1|+0610' },
			{ categoria: 'MC_P-CodLineaProdotto|45', serie: 'MC_P-Cod.Serie1|+4608' },
			{ categoria: 'MC_P-CodLineaProdotto|80', serie: 'MC_P-Cod.Serie1|+8108' },
		],
	],
};
